import React from 'react';
import FormField from '../form/FormField';
import {createFragmentContainer, graphql, } from "react-relay";
import PropTypes from "prop-types";
import {Constraint} from "@aperza/validator";

class FormBusinessTypeField extends React.Component {

  static propTypes = {
    viewer: PropTypes.any,
    readOnly: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  };

  onBlur(fieldName, value) {
    if (this.props.onBlur) {
      this.props.onBlur(fieldName, value);
    }
  }

  onChange(fieldName, value) {
    if (this.props.onChange) {
      this.props.onChange(fieldName, value);
    }
  }

  render() {
    let {
      readOnly,
      errorId,
      invalid,
      value,
    } = this.props;


    let options = this.props.viewer.businessTypes.map(businessType => {
      return [businessType.name, businessType.label];
    });
    return (
      <FormField
        fieldName={'business_types'}
        options={options}
        readOnly={readOnly}
        invalid={invalid}
        errorId={errorId}
        value={value}
        onBlur={::this.onBlur}
        onChange={::this.onChange}  />
    )
  }

}

export default createFragmentContainer(
  FormBusinessTypeField,
  {
    viewer: graphql`
        fragment FormBusinessTypeField_viewer on Viewer {
            businessTypes {
                id
                plainId
                name
                label
            }
        }
    `
  });
